import { render, staticRenderFns } from "./CreateDocumentCompetitors.vue?vue&type=template&id=98b59018&scoped=true&"
import script from "./CreateDocumentCompetitors.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentCompetitors.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocumentCompetitors.vue?vue&type=style&index=0&id=98b59018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b59018",
  null
  
)

export default component.exports